export default __webpack_public_path__ + "static/media/volkihar-book-large.5765df70.png";